import { use, useEffect, useState } from "react";
import { Icon } from "../../global-components/src/components/icon";
import { t } from "../../global-components/src/i18nTranslate";
import "./style.css";
import Screen from "../Layouts/Screen/Screen";
import { Helmet } from "react-helmet-async";
import { RequestCompanySealStep1 } from "./step1";
import { useAuth, useMessage } from "../../global-components/src";
import axios from "axios";
import { api } from "../../services/api";
import { PaymentTypes } from "../../global-components/src/types";
import { errorMessage } from "../../utils/TextManagerTwo";
import { useNavigate } from "react-router-dom";
import { logEvent } from "../../components/analytics-tracker";
import Spinner from "../../global-components/src/components/spinner/spiner";
import { BadgeCheck, CreditCard, Clipboard } from "lucide-react";
import { isValidCNPJ, isValidEmail, isValidWebsite } from "../../global-components/src/utils/text";

export function RequestCompanySeal(){
    const { user, token } = useAuth();
    const [step, setStep] = useState(1);
    const [errorsInput, setErrorsInput] = useState<any>({});
    const [corporateReason, setCorporateReason] = useState<string>("");
    const [businessName, setBusinessName] = useState<string>("");
    const [cnpj, setCnpj] = useState<string>("");
    const [cnpjCard, setCnpjCard] = useState<File | null>(null);
    const [responsibleDocument, setResponsibleDocument] = useState<File | null>(null);
    const [socialContract, setSocialContract] = useState<File | null>(null);
    const [website, setWebsite] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [copiado, setCopiado] = useState(false);
    const [loading, setLoading] = useState(false);
    const [forceShowForm, setForceShowForm] = useState(false);
    const [loadingVerifyPayment, setLoadingVerifyPayment] = useState(false);
    const [loadingVerifyPaymentSecondPPlan, setLoadingVerifyPaymentSecondPlan] = useState(false);
    const [requestBadge, setRequestBadge] = useState<any>(() => {
        const savedQrCode = localStorage.getItem(`requestBadgeCompanySeal-${user?.id}`);
        return savedQrCode ? savedQrCode : null;
    });
    const [qrCode, setQrCode] = useState<any>(() => {
        const savedQrCode = localStorage.getItem("qrCodeCompanySeal");
        return savedQrCode ? savedQrCode : null;
    });
    const [copyPaste, setCopyPaste] = useState<string | null>(() => {
        const saved = localStorage.getItem("copyPasteCompanySeal");
        return saved ? saved : null;
    });
    const [transaction, setTransaction] = useState<any>(() => {
        const saved = localStorage.getItem("transactionCompanySeal");
        return saved ? JSON.parse(saved) : null;
    });
    const [months, setMonths] = useState(1);
    const valuePerMonth = 49.99;
    const total = months * valuePerMonth;
    const [paymentMethod, setPaymentMethod] = useState<PaymentTypes>("wallet");
    const [walletBalance, setWalletBalance] = useState<number>(0);
    const [loadinWallet, setLoadingWallet] = useState<boolean>(true);
    const [oldValue, setOldValue] = useState<string>(localStorage.getItem("oldValueCompanySeal") || "");
    const navigate = useNavigate();
    const { setMessage } = useMessage();
    
    useEffect(() => {
        if (qrCode) localStorage.setItem("qrCodeCompanySeal", qrCode);
        if (copyPaste) localStorage.setItem("copyPasteCompanySeal", copyPaste);
        if (transaction) localStorage.setItem("transactionCompanySeal", JSON.stringify(transaction));
        if (total && !qrCode) localStorage.setItem("oldValueCompanySeal", String(total));
    }, [qrCode, copyPaste, transaction, total]);

    useEffect(() => {
        setLoadingWallet(true);
        api(token).get(`/wallet`).then(res => {
            setWalletBalance(Number(res.data.balance));
        }).finally(() => {
            setLoadingWallet(false);
        });
    }, []);

    useEffect(() => {
        if(requestBadge) setStep(-1);
    }, [requestBadge]);

    useEffect(() => {
        loadCompanyData();
    }, []);

    useEffect(() => {
        if(user?.company){
            setCorporateReason(user.company.corporate_reason);
            setBusinessName(user.company.business_name);
            setCnpj(user.company.cnpj);
            setWebsite(user.company.website);
            setEmail(user.company.email);
        }
    }, [user?.company]);

    const loadCompanyData = async () => {
        try {
            const response = await api(token).get(`/companies`);
            const data = response.data;
            setCorporateReason(data.corporate_reason);
            setBusinessName(data.business_name);
            setCnpj(data.cnpj);
            setWebsite(data.website);
            setEmail(data.email);
        } catch (error) {
            console.error(error);
        }
    }

    const copyLink = async () => {
        if(!copyPaste) return;
        try {
            await navigator.clipboard.writeText(copyPaste);
            setCopiado(true);
            setTimeout(() => setCopiado(false), 2000);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (user?.is_company && user.is_verified_company){
            navigate("/verificado");
            return;
        }
    }, [user]);

    useEffect(() => {
        const interval = setInterval(() => {
            if(transaction?.gateway_txid) verifyPayment();
        }, 500); // Verifica a cada 5 segundos

        return () => clearInterval(interval); // Limpa o intervalo ao desmontar o componente
    }, [transaction]);

    const formatDate = (date: any) => {
        const d = new Date(date + 'T00:00:00'); // força horário local meia-noite
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    }

    const verifyPayment = async (manual = false) => {
        if(manual) setLoadingVerifyPayment(true);
        if(!manual && (loadingVerifyPayment || loadingVerifyPaymentSecondPPlan)) return;  
        setLoadingVerifyPaymentSecondPlan(true);
        
        try {
            const response = await api(token).post(`/companies/verified/verify-payment`, {
                gateway_txid: transaction.gateway_txid,
            },{
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // Adicione o token aqui
                }
            });

            if(response.data.status == "completed"){
                setMessage(`Pagamento confirmado. Seu selo será analizado e adicionado em até 72 horas.`, "success");
                localStorage.setItem(`requestBadgeCompanySeal-${user?.id}`, "true");
                cancel()
                navigate(`/@${user?.user_name}`);
                return;
            }

            if(manual){
                setMessage(`Pagamento não confirmado, espere mais alguns minutos`, "warning");
            }
            
        } catch (err: any) {
            const messageError = errorMessage(err);
                                    
            if (err?.response?.data.errors) {
                setErrorsInput(err.response.data.errors); // Atualiza o estado com os erros
            } else {
                setMessage(messageError, "error")
            }
            console.error(messageError);
            console.error(err);
        } finally {
            setLoadingVerifyPaymentSecondPlan(false);  
            setLoadingVerifyPayment(false)
        }
    };

    const submit = async () =>{
        setLoading(true);
        setErrorsInput({});

        logEvent("novo_verificado", {
            categoria: "Verificado",
            acao: "Novo verificado",
        });

        try {
            const formData = new FormData();

            formData.append("months", String(months));
            formData.append("gateway", paymentMethod);

            formData.append("cnpj", cnpj.replace(/\D/g, ""));
            formData.append("corporate_reason", corporateReason);
            formData.append("business_name", businessName);
            formData.append("website", website);
            formData.append("email", email);
            if (cnpjCard) formData.append("cnpj_card", cnpjCard);
            if (responsibleDocument) formData.append("responsible_document", responsibleDocument);
            if (socialContract) formData.append("social_contract", socialContract);

            const response = await api(token).post(`/companies/verified`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });

            if(paymentMethod == "wallet"){
                localStorage.setItem(`requestBadgeCompanySeal-${user?.id}`, "true");
                setMessage(user?.stamps?.includes("black") ? "Selo renovado" : `Seu selo será analizado e adicionado em até 72 horas`, "success");
                cancel()
                navigate(`/@${user?.user_name}`)
                return;
            }

            setTransaction(response.data.transaction);
            // Se for PIX, mostra QR e copia-e-cola
            if(response.data.gateway_data?.qrcode){
                setQrCode(response.data.gateway_data.qrcode);
                setCopyPaste(response.data.gateway_data.copyPaste);
            }
            setForceShowForm(false);

            // setQrCode(response.data.qrcode);
            // setPix(response.data.pix);
        } catch (err: any) {
            const messageError = errorMessage(err);
            setStep(2);
                                    
            if (err?.response?.data.errors) {
                setErrorsInput(err.response.data.errors); // Atualiza o estado com os erros
            } else {
                setMessage(messageError, "error")
            }
            console.error(messageError);
            console.error(err);
        }
        setLoading(false)
    }

    const getVerifiedUntil = () => {
        var base = user?.next_payment
            ? new Date(String(user?.next_payment)?.replace(" ", "T"))
            : new Date();
        base.setDate(base.getDate() + 1);
        base = base;

        if (isNaN(base.getTime())) return "Data inválida";

        base.setMonth(base.getMonth() + months);
        return formatDateTwo(base);
    };

    const formatDateTwo = (date: any) => {
        const d = new Date(date);
        if (isNaN(d.getTime())) return "Data inválida";

        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    };

    
    useEffect(() => {
        if(total > walletBalance) setPaymentMethod("gerencianet_pix");
    }, [total])

    useEffect(() => {
        if(total && !qrCode) setOldValue(months * valuePerMonth + "")
        if (total && !qrCode) localStorage.setItem("oldValueCompanySeal", String(total));
    }, [months]);

    
    const next = () => {
        if(step == 2){
            const validate = validateForm();
            if(Object.keys(validate).length > 0){
                setErrorsInput(validate);
                return;
            }
        }

        if(step == 3){
            submit();
            return;
        }

        setStep(step + 1);
    }

    const handleCnpjInput = async(e: any) => {
        const value = e.target.value.replace(/\D/g, '').replace(/(\d{2})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1-$2");
        setCnpj(value);

        if(value.length === 17){
            try {
                const response = await api(token).get(`/companies/cnpj/${value.replace(/\D/g, '')}`);
                const data = response.data;
                setCorporateReason(data.nome);
                setBusinessName(data.fantasia);
                setWebsite(data.site);
                setEmail(data.email);
            } catch (error) {
                console.error(error);
            }
        }
    }

    const validateForm = () => {
        const errors: any = {};

        if (!corporateReason?.trim()) {
            errors.corporate_reason = [
                t("errors.input.required", { field: t("company.info.corporateReason") })
            ];
        }

        if (!businessName?.trim()) {
            errors.business_name = [
                t("errors.input.required", { field: t("company.info.businessName") })
            ];
        }

        if (businessName && businessName !== user?.name) {
            errors.business_name = [
                t("errors.input.wrongBusinessName")
            ];
        }

        if (!cnpj) {
            errors.cnpj = [
                t("errors.input.required", { field: t("company.info.cnpj") })
            ];
        } else if (!isValidCNPJ(cnpj)) {
            errors.cnpj = [
                t("errors.input.invalid", { field: t("company.info.cnpj") })
            ];
        }

        if (!website?.trim()) {
            errors.website = [
                t("errors.input.required", { field: t("company.info.website") })
            ];
        } else if (!isValidWebsite(website)) {
            errors.website = [
                t("errors.input.invalid", { field: t("company.info.website") })
            ];
        }

        if (!email?.trim()) {
            errors.email = [
                t("errors.input.required", { field: t("company.info.email") })
            ];
        } else if (!isValidEmail(email)) {
            errors.email = [
                t("errors.input.email", { field: t("company.info.email") })
            ];
        }

        if (!cnpjCard) {
            errors.cnpj_card = [
                t("errors.input.required", { field: t("generics.value") })
            ];
        }

        if (!responsibleDocument) {
            errors.responsible_document = [
                t("errors.input.required", { field: t("generics.value") })
            ];
        }

        if (!socialContract) {
            errors.social_contract = [
                t("errors.input.required", { field: t("generics.value") })
            ];
        }

        const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

        if (cnpjCard && cnpjCard.size > MAX_FILE_SIZE) {
            errors.cnpj_card = [t("errors.input.invalid", { field: t("generics.value") })];
        }

        return errors;
    };
    const cancel = () => {
        setStep(1);
        localStorage.removeItem("qrCodeCompanySeal")
        localStorage.removeItem("copyPasteCompanySeal")
        localStorage.removeItem("transactionCompanySeal")
        localStorage.removeItem("oldValueCompanySeal")
    }
    
    return (
        <Screen paddingTopTitle={true} title={window.innerWidth <= 850 ? t("company.requestSeal.stamp") : " "}>
            <Helmet>
                <title>Paçoca - {t("company.requestSeal.title")}</title>
                <meta name="description" content={`Seja ${t("company.requestSeal.title")} no Paçoca, a rede dos brasileiros!`}/>
                <meta name="keywords" content={`Paçoca, rede social brasileira, ${t("company.requestSeal.title")}, premium, pagamento}`}/>
                <meta name="author" content="Paçoca Inc."/>
                <meta property="og:title" content={`Paçoca - ${t("company.requestSeal.title")}`}/>
                <meta property="og:description" content={`Seja ${t("company.requestSeal.title")} no Paçoca, a rede dos brasileiros!`}/>
                <meta property="og:image" content="/img/link-preview.png?v=1" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:url" content={window.location.href}/>
                <meta property="og:type" content="website"/>
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:title" content={`Paçoca - ${t("company.requestSeal.title")}`}/>
                <meta name="twitter:description" content={`Seja ${t("company.requestSeal.title")} no Paçoca, a rede dos brasileiros!`}/>
                <meta name="twitter:image" content="/img/link-preview.png?v=1" />
        </Helmet>

        <div className="padding-big-screen">
            <div className="bank-tx">
                {forceShowForm || !qrCode && (!user?.stamps?.includes("black")) ? (
                    <div >
                        {!requestBadge && (
                            <>
                                <div className="bank-hero">
                                    <div className="foc-premium-icon">
                                        <BadgeCheck size={26} />
                                    </div>
                                    <h5 className="bank-hero-title">
                                        {t("company.requestSeal.stamp")}
                                    </h5>
                                    <p className="foc-qr-hint" style={{ marginBottom: 0 }}>
                                        <span className="current-value">
                                            {t("company.requestSeal.value")}
                                        </span>{" "}
                                        <span className="old-value">
                                            {t("company.requestSeal.oldValue")}
                                        </span>
                                    </p>
                                </div>
                            </>
                        )}
                        
                        {requestBadge && (
                            <p className="text-center">{t("company.requestSeal.wait")}</p>
                        )}
                        

                        {step === 1 && (
                            <RequestCompanySealStep1/>
                        )}

                        {step === 2 && (
                            <div className="">
                                <div className="m">
                                    <div className="col">
                                        <label htmlFor="cnpj">{t("company.info.cnpj")}</label>
                                        <input autoCapitalize="none" placeholder={t("company.info.cnpj")} id="cnpj" type="text" value={cnpj} onChange={handleCnpjInput} className={`form-control form-request-company-seal ${errorsInput.cnpj ? 'is-invalid' : ''}`} name="cnpj" autoComplete="cnpj" />
                                        {errorsInput.cnpj && (
                                            <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.cnpj[0]}</div>
                                        )}
                                    </div>
                                </div>

                                <div className="mt-3">
                                    <div className="col">
                                        <label htmlFor="corporate_reason">{t("company.info.corporateReason")}</label>
                                        <input autoCapitalize="none" placeholder={t("company.info.corporateReason")} id="corporate_reason" type="text" value={corporateReason} onChange={(e) => setCorporateReason(e.target.value)} className={`form-control form-request-company-seal ${errorsInput.corporate_reason ? 'is-invalid' : ''}`} name="corporate_reason" autoComplete="corporate_reason" />
                                        {errorsInput.corporate_reason && (
                                            <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.corporate_reason[0]}</div>
                                        )}
                                    </div>
                                </div>

                                <div className="mt-3">
                                    <div className="col">
                                        <label htmlFor="business_name">{t("company.info.businessName")}</label>
                                        <input autoCapitalize="none" placeholder={t("company.info.businessName")} id="business_name" type="text" value={businessName} onChange={(e) => setBusinessName(e.target.value)} className={`form-control form-request-company-seal ${errorsInput.business_name ? 'is-invalid' : ''}`} name="business_name" autoComplete="business_name" />
                                        <div style={{marginTop: "5px"}} id="passwordHelp" className="form-text">{t("company.requestSeal.obs")}</div>
                                        {errorsInput.business_name && (
                                            <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.business_name[0]}</div>
                                        )}
                                    </div>
                                </div>

                                <div className="mt-3">
                                    <div className="col">
                                        <label htmlFor="website">{t("company.info.website")}</label>
                                        <input autoCapitalize="none" placeholder={t("company.info.website")} id="website" type="text" value={website} onChange={(e) => setWebsite(e.target.value)} className={`form-control form-request-company-seal ${errorsInput.website ? 'is-invalid' : ''}`} name="website" autoComplete="website" />
                                        {errorsInput.website && (
                                            <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.website[0]}</div>
                                        )}
                                    </div>
                                </div>

                                <div className="mt-3">
                                    <div className="col">
                                        <label htmlFor="email">{t("company.info.email")}</label>
                                        <input autoCapitalize="none" placeholder={t("company.info.email")} id="email" type="text" value={email} onChange={(e) => setEmail(e.target.value)} className={`form-control form-request-company-seal ${errorsInput.email ? 'is-invalid' : ''}`} name="email" autoComplete="email" />
                                        {errorsInput.email && (
                                            <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.email[0]}</div>
                                        )}
                                    </div>
                                </div>

                                <div className="mt-4">
                                    <div className="col">
                                        <label htmlFor="cnpj_card">Cartão CNPJ (PDF ou imagem)</label>
                                        <input
                                            id="cnpj_card"
                                            type="file"
                                            accept=".pdf,.png,.jpg,.jpeg"
                                            onChange={(e) => setCnpjCard(e.target.files?.[0] || null)}
                                            className={`form-control ${errorsInput.cnpj_card ? 'is-invalid' : ''}`}
                                        />
                                        {errorsInput.cnpj_card && (
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {errorsInput.cnpj_card[0]}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="mt-3">
                                    <div className="col">
                                        <label htmlFor="responsible_document">Documento do Responsável (RG ou CNH)</label>
                                        <input
                                            id="responsible_document"
                                            type="file"
                                            accept=".pdf,.png,.jpg,.jpeg"
                                            onChange={(e) => setResponsibleDocument(e.target.files?.[0] || null)}
                                            className={`form-control ${errorsInput.responsible_document ? 'is-invalid' : ''}`}
                                        />
                                        {errorsInput.responsible_document && (
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {errorsInput.responsible_document[0]}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="mt-3">
                                    <div className="col">
                                        <label htmlFor="social_contract">Contrato Social (PDF)</label>
                                        <input
                                            id="social_contract"
                                            type="file"
                                            accept=".pdf"
                                            onChange={(e) => setSocialContract(e.target.files?.[0] || null)}
                                            className={`form-control ${errorsInput.social_contract ? 'is-invalid' : ''}`}
                                        />
                                        {errorsInput.social_contract && (
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                                {errorsInput.social_contract[0]}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {step == 3 && (
                            <>
                                <div className="row">
                                    <div className="col-12 mb-4">
                                        <h5 className="mb-3 mt-3">Duração do plano</h5>
                                        
                                        <div className="mb-3">
                                        <select 
                                            value={months} 
                                            className="form-select" 
                                            onChange={(e) => setMonths(Number(e.target.value))}
                                        >
                                            {[...Array(12)].map((_, i) => {
                                            const mes = i + 1;
                                            return (
                                                <option key={mes} value={mes}>
                                                {mes} {mes === 1 ? "mês" : "meses"}
                                                </option>
                                            );
                                            })}
                                        </select>
                                        </div>

                                        {/* <div className="alert alert-info py-2">
                                            <small>
                                                <i className="bi bi-calendar-event me-2"></i>
                                                Seu verificado ficará ativo até: <strong>{getVerifiedUntil()}</strong>
                                            </small>
                                        </div> */}

                                        <h5 className="mt-4 mb-3">Método de Pagamento</h5>
                                        <div className="list-group">
                                            <label className={`list-group-item notification_opened d-flex gap-3 align-items-center`} style={{ cursor: 'pointer', opacity: total > walletBalance ? .7 : 1 }}>
                                                <input className="form-check-input flex-shrink-0" type="radio" name="payMethod" checked={paymentMethod === "wallet"} disabled={total > walletBalance} onChange={() => setPaymentMethod("wallet")}/>
                                                <span>
                                                    Saldo da Carteira
                                                    <small className="d-block opacity-75">
                                                        {loadinWallet ? "Carregando..." : `Disponível: R$ ${walletBalance.toFixed(2).replace(".", ",")}`}
                                                    </small>
                                                </span>
                                            </label>

                                            <label className={`list-group-item d-flex gap-3 notification_opened align-items-center`} style={{ cursor: 'pointer' }}>
                                                <input className="form-check-input flex-shrink-0" type="radio" name="payMethod" checked={paymentMethod === "gerencianet_pix"} onChange={() => setPaymentMethod("gerencianet_pix")}/>
                                                <span>
                                                    Pix (Aprovação Instantânea)
                                                    <small className="d-block opacity-75">O QR Code será gerado após confirmar</small>
                                                </span>
                                            </label>
                                        </div>
                                    </div>

                                    {/* Resumo do Pedido */}
                                    <div className="col-12 mt-4 mt-lg-0">
                                        <div className="card notification_opened border-0">
                                        <div className="card-body">
                                            <h6 className="card-title mb-3">Resumo do Pedido</h6>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span>Mensalidade</span>
                                                <span>R$ {valuePerMonth.toFixed(2).replace(".", ",")}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span>Período</span>
                                                {/* <span>{months}x</span> */}
                                                <span>{getVerifiedUntil()}</span>
                                            </div>
                                            <hr />
                                            <div className="d-flex justify-content-between mb-4">
                                                <span className="fw-bold">Total</span>
                                                <span className="fw-bold h5" style={{ color: "var(--secondary-black)" }}>R$ {total.toFixed(2).replace(".", ",")}</span>
                                            </div>

                                        
                                            {/* {forceShowForm && (
                                            <button 
                                                type="button" 
                                                onClick={() => setForceShowForm(false)} 
                                                className="btn btn-link w-100 mt-2 text-muted"
                                            >
                                                {t("generics.cancel")}
                                            </button>
                                            )} */}
                                        </div>
                                        </div> 
                                    </div>
                                    </div>
                            </>   
                        )}


                        {!requestBadge && (
                            <div>

                                <div className="space-button"></div>

                                <div className="foc-actions" style={{ marginTop: 18 }}>
                                    <button onClick={next} className="foc-btn foc-btn-primary">
                                        {loading ? <Spinner size="20px" /> : (
                                            step <=2 ? t("generics.continue") : t("generics.finish")
                                        )}
                                    </button>
                                </div>
        
                                {step > 1 && (
                                    <button type="button" onClick={cancel} className="foc-cancel-link">
                                        {t("generics.cancel")}
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                ) : null }

                {!forceShowForm && !qrCode && user?.stamps?.includes("black") ? (
                    <div className="user-select-none row mt-5">
                        <span className="span-empty">
                            <BadgeCheck className="icon-empty" />
                            <h3 className="w-100 text-center">
                                {user?.next_payment ? `Verificado até ${formatDate(user.next_payment)}` : "Verificado para sempre"}
                            </h3>

                            {user?.next_payment ? (
                                <a className="mt-3 link cursor-pointer" onClick={() => setForceShowForm(true)}>renovar</a>
                            ) : null}
                        </span>
                    </div>
                ) : null }


                {qrCode ? (
                    <>
                        <p className="w-100">Pague pelo QRCode ou copie o código no seu banco favorito:</p>
                        <h3 className="w-100 text-center" style={{marginTop: ""}}>R$ { oldValue ?? 5 }</h3>
                        
                        <div className="d-flex">
                            <img src={qrCode} width="300" alt="QR Code PIX" style={{margin: "0 auto"}}/>
                        </div>
                        
                        
                        <div className="w-100 text-center mb-5">
                            <button onClick={cancel} type="button" className="btn link mr-2">
                                Cancelar
                            </button>
                        </div>

                        <div className="mt-2 d-flex justify-content-center gap-2">

                            <button onClick={copyLink} type="button" className="btn btn-blue" style={{marginTop: ""}}>
                                <Clipboard style={{height: "20px", marginRight: "9px"}}/>
                                {copiado ? "Copiado!" : "Copiar código"}
                            </button>

                            <button disabled={loadingVerifyPayment} onClick={() => verifyPayment(true)} type="button" className="foc-btn foc-btn-primary">
                                {loadingVerifyPayment ? (
                                    <Spinner size="20px"/>
                                ) : (
                                    <div>
                                            <CreditCard style={{height: "20px", marginRight: "9px"}}/> Verificar Pagamento
                                    </div>
                                )} 
                            </button>
                        </div>
                    </>
                ) : null}
            </div>
        </div>
        </Screen>
    );
}